import { Calendar, Col, Row } from 'antd'
import moment from 'moment'
import React from 'react'
import styled from 'styled-components'
import { EmptyElement } from '../UIComponents/CommonStyledDiv'

const MiniDateCal = styled(Calendar)`
  .ant-picker-content {
    background: #fafafb !important;
  }
  .ant-picker-panel {
    background: #fff;
    border: 0;
    border-top: 0px solid #f0f0f0 !important;
    border-radius: 0;
  }

  .ant-picker-calendar-mini .ant-picker-content th {
  }

  .ant-picker-body {
    padding: 0px 0 !important;
  }
  td {
    border: 0px !important;
  }
  .ant-picker-cell {
    position: relative;
  }
  .ant-picker-cell-in-view {
    color: #4d566e !important;
  }
  .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner,
  .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner,
  .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner {
    height: 35px !important;
    width: 35px !important;
    border-radius: 50% !important;
    justify-content: center !important;
    padding-top: 5px !important;
  }
  .ant-picker-cell-in-view.ant-picker-cell-today
    .ant-picker-cell-inner::before {
    border: 0px !important;
  }
`

const CalenderStyled = ({
  fullscreen = false,
  calendarValue = moment(),
  setDate,
  allDate,
  setFromDate,
  fromDate,
  headerRender,
}) => {
  const currentDate = moment()

  const dateCellRender = value => {
    const handleClick = () => {
      const formattedDate = value.format('YYYY-MM-DD')
      setFromDate(formattedDate)
    }

    let cellStyle = {
      borderRadius: '50%',
      padding: '8px',
      outline: 'none',
      border: 'none',
      background: 'unset',
    }
    if (value?.isSame(moment(fromDate), 'day')) {
      cellStyle.background = '#3249D7'
      cellStyle.color = 'white'
    } else if (value?.isSame(currentDate, 'day')) {
      cellStyle.border = '1px solid #3249D7'
      cellStyle.color = '#3249D7'
    } else if (allDate?.some(date => value?.isSame(date?.date, 'day'))) {
      if (value?.isBefore(currentDate, 'day')) {
        cellStyle.background = '#DCE0F6'
        cellStyle.color = '#3249D7'
      } else if (value?.isAfter(currentDate, 'day')) {
        cellStyle.border = '1px solid #3249D7'
        cellStyle.color = '#3249D7'
      }
    }

    return (
      <EmptyElement
        style={{
          ...cellStyle,
          cursor: 'pointer',
        }}
        onClick={handleClick}
      >
        {value.date()}
      </EmptyElement>
    )
  }

  const onPanelChange = (value, mode) => {
    if (mode === 'date') {
      setDate(value)
    }
  }

  return (
    <Row>
      <Col span={24}>
        <MiniDateCal
          fullscreen={fullscreen}
          dateFullCellRender={dateCellRender}
          onPanelChange={onPanelChange}
          headerRender={({ value = calendarValue, onChange }) =>
            headerRender({ value: value, onChange: onChange })
          }
        />
      </Col>
    </Row>
  )
}

export default CalenderStyled
